import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { Section } from "@/components/Section";
import { KeyIdea, Tip } from "@/components/Callouts";

export default function EdSheeran4() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "4");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section title="Chord Chart">
        <NoteImage
          src="/notes/ed-sheeran/finals/04-old-phone.png"
          caption="Jason's chord chart for Old Phone"
        />
      </Section>

      <Section title="Verse & Chorus">
        <RomanNumeralAnalysis
          label="Verse · B♭ major"
          chords={[
            { chord: "Bb", rn: "I", function: "Tonic", pitches: ["Bb2", "D3", "F3", "Bb3"] },
            { chord: "F", rn: "V", function: "Dominant", pitches: ["F2", "A2", "C3", "F3"] },
            { bar: true },
            { chord: "Ebadd9", rn: "IVadd9", function: "Pre-dominant", pitches: ["Eb3", "G3", "Bb3", "F4"] },
            { chord: "Bb", rn: "I", function: "Tonic", pitches: ["Bb2", "D3", "F3", "Bb3"] },
            { chord: "F", rn: "V", function: "Dominant", pitches: ["F2", "A2", "C3", "F3"] },
          ]}
        />
        <RomanNumeralAnalysis
          label="Chorus · B♭ major"
          chords={[
            { chord: "Gm7", rn: "vi7", function: "Submediant", pitches: ["G2", "D3", "F3", "Bb3"] },
            { chord: "Ebadd9", rn: "IVadd9", function: "Pre-dominant", pitches: ["Eb3", "G3", "Bb3", "F4"] },
            { bar: true },
            { chord: "Bb", rn: "I", function: "Tonic", pitches: ["Bb2", "D3", "F3", "Bb3"] },
            { chord: "F", rn: "V", function: "Dominant", pitches: ["F2", "A2", "C3", "F3"] },
          ]}
        />
        <KeyIdea title="Special moment">
          E♭add9 is the IV chord with one extra note: E♭–G–B♭ plus F, the 9th. Jason's chart
          writes it as E♭add9 in both the verse and the chorus. Play plain E♭, then E♭add9, and
          listen for that added F.
        </KeyIdea>
        <Tip>
          Same function, different colour: add9 on a IV chord keeps it pointing where it always
          pointed, with a softer, more open sound.
        </Tip>
      </Section>

      <Section title="Watch">
        <YouTubeEmbed videoId="rj5dxoMY-dE" />
      </Section>
    </LessonShell>
  );
}
